import MuiEditIcon from "@material-ui/icons/Edit";

const EditIcon = MuiEditIcon;

export default EditIcon;